import {handleActions} from 'redux-actions';
import {Record} from 'immutable';
import moment from 'moment-timezone';

import {REPORT_CONFIG} from 'web-app/react/child-development/constants';

import * as Actions from './actions';

const ChildDevelopmentOverview = Record({
    viewMode: REPORT_CONFIG.EYFS_STATEMENT_TRACKING,
    asOf: moment(),
});

export default handleActions(
    {
        [Actions.setViewMode.type]: (state, {payload}) =>
            state.merge({
                viewMode: payload.viewMode,
            }),
        [Actions.setAsOf.type]: (state, {payload}) =>
            state.merge({
                asOf: payload.asOf,
            }),
    },
    new ChildDevelopmentOverview(),
);
